<script>

export default {
  components: {
  },
  props: {
    value: Boolean,
    module: Object,
  },
};
</script>
<template>
  <v-menu
    :value="value"
    @input="$emit('input', $event)"
    left
    bottom
    offset-y
    :close-on-click="false"
    max-height="80vh"
    min-width="300px"
    max-width="420px"
    :disabled="!module.items.length"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        :disabled="!module.items.length"
      >
        <v-icon>mdi-information</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, idx) in module.items"
        :key="idx"
        target="_blank"
        :href="item.link"
      >
        <v-list-item-action v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
